enum KeyboardKey {
  LEFT = 37,
  RIGHT = 39,
  DOWN = 40,
  SPACE = 32,
  Q = 81,
  W = 87,
}

export default KeyboardKey;
